<template>
  <div class="pubTopManage">
  </div>
</template>

<script>
  import { prepare } from '@/api/pages'
  import Axios from "@/api/diyaxios";
  import Cookies from 'js-cookie'
  export default {
    data() {
      return {
        preparename: "",
      }
    },

    created() {

    },
    mounted() {
      this.getprepare()
    },
    methods: {
      async getprepare() {
        try {
          const res = await Axios.post(
            "/rmd/rmdsetting/gettiaozhuan", {},
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          const cookieOptions = { path: '/' };
          if (res.data == 0) {
            Cookies.set('logintype', 0, cookieOptions);
            this.$router.push({ name: "HomePage" })
          }
          else if (res.data == 1) {
            Cookies.set('logintype', 1, cookieOptions);
            this.$router.push({ name: "Xindex" })
          } else {
            Cookies.set('logintype', 1, cookieOptions);
            this.$router.push({ name: "Xindex" })
          }
        } catch (e) {
          // 接口异常(如 404 路由未注册)时兜底跳转，避免停留在空白预热页
          // 默认按既有 else 逻辑跳转采购平台首页
          const cookieOptions = { path: '/' };
          Cookies.set('logintype', 1, cookieOptions);
          this.$router.push({ name: "Xindex" });
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .pubTopManage {
    background-color: #f9f9f9;
  }
</style>


// WEBPACK FOOTER //
// src/views/Preparationpage/Preparationpage.vue